export default {
  "content": "<path fill=\"#028EB7\" d=\"M7.84 15.68a7.837 7.837 0 110-15.673 7.837 7.837 0 010 15.673zm3.1-6.383L8.774 7.344l-.442-4.288a.493.493 0 00-.98 0L6.858 7.84a.776.776 0 00.451.785l3.121 1.457a.474.474 0 00.51-.786z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16"
  }
};